import React, { useState } from 'react';
import { getFileDisplayUrls } from '../../utils/cloudinaryDelivery';

function CloudinaryDocumentViewer({ fileMeta, label = 'Document' }) {
  const [loadError, setLoadError] = useState(false);
  const urls = getFileDisplayUrls(fileMeta);

  if (!urls?.viewUrl) {
    return <p className="text-sm text-gray-500">No file uploaded.</p>;
  }

  const isPdf =
    fileMeta?.format === 'pdf' ||
    fileMeta?.originalName?.toLowerCase().endsWith('.pdf') ||
    fileMeta?.publicId?.toLowerCase().endsWith('.pdf') ||
    urls.viewUrl?.toLowerCase().includes('.pdf');

  const srcUrl = urls.viewUrl || urls.downloadUrl;

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-medium text-gray-800">{label}</p>
        <div className="flex gap-3 text-sm">
          <a
            href={urls.downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-iof hover:underline"
          >
            Download
          </a>
          <a
            href={urls.viewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-iof hover:underline"
          >
            Open in new tab
          </a>
        </div>
      </div>

      {isPdf && srcUrl && !loadError ? (
        <div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50">
          <iframe
            title={`${label} preview`}
            src={srcUrl}
            className="w-full h-[min(70vh,520px)]"
            onError={() => setLoadError(true)}
          />
        </div>
      ) : (
        <p className="text-sm text-gray-600 p-4 bg-gray-50 rounded-lg border border-gray-200">
          Preview is not available for this file type. Use Download or Open in new tab.
        </p>
      )}

      {isPdf && urls.previewUrl && urls.previewUrl !== urls.viewUrl && (
        <img
          src={urls.previewUrl}
          alt={`${label} first page`}
          className="max-w-full rounded border border-gray-200"
          onError={() => {}}
        />
      )}
    </div>
  );
}

export default CloudinaryDocumentViewer;
